// extracted by mini-css-extract-plugin
export default {"content":"Posts_content__SRZqT"};